window.stripWindowsLocationPath = function () {
    // TODO - Required Auto reflect change here, if new lang added
    //<%= Rails.application.config.i18n.available_locales %>
    var supportedLocales = ["en", "de", "fr", "ru", "es"];
    var regex = new RegExp(supportedLocales.map(function(lang){return '\/'+lang+'\/';}).join("|"), 'gi')
    return window.location.pathname.replace(regex, '/')
}
